import { useRef, useState } from 'react';
import { usePreviousValue } from '../../../../hooks/usePreviousValue';
import { remToPX } from '../utils/ColorPickerUtil';

// constants - in rem unit.
export const FIELD_MIN_WIDTH = 3.875;
export const CONTAINER_MIN_WIDTH = 12.125;
export const DEFAULT_GAP = 0.5;

/**
 * Hook to dynamically calculate the colorpicker container width and input field width based on the
 * input field's label width.
 * @returns container width, field width and refs to set on label and wrapper container
 */
export const useColorPickerDimensions = () => {
  const labelContainerRef = useRef(null);
  const wrapperRef = useRef(null);
  const [fieldWidth, setFieldWidth] = useState(remToPX(FIELD_MIN_WIDTH));
  const [containerWidth, setContainerWidth] = useState(remToPX(CONTAINER_MIN_WIDTH));
  const prevFieldWidth = usePreviousValue(fieldWidth);
  const calculateDimensions = () => {
    const labelContainer = labelContainerRef.current;
    const wrapper = wrapperRef.current;
    if (!labelContainer) return;
    const minFieldWidth = remToPX(FIELD_MIN_WIDTH);
    const fieldWidth = Math.max(minFieldWidth, labelContainer.getBoundingClientRect().width ?? minFieldWidth);
    if (fieldWidth === prevFieldWidth) return;
    let gap = remToPX(DEFAULT_GAP);
    if (wrapper) gap = 2 * parseFloat(getComputedStyle(wrapper).gap);
    const minContainerWidth = remToPX(CONTAINER_MIN_WIDTH);
    const containerWidth = Math.max(minContainerWidth, fieldWidth * 3 + gap);
    setFieldWidth(fieldWidth);
    setContainerWidth(containerWidth);
  };
  return {
    fieldWidth,
    containerWidth,
    wrapperRef,
    labelContainerRef,
    calculateDimensions
  };
};
//# sourceMappingURL=useColorPickerDimensions.js.map